const AbstractSyncer = require('@/lib/Syncing/AbstractSyncer');
const logFactory = require('@/libraries/DigiTickets/Logging/logFactory');

/**
 * This is a strange Syncer because we don't "sync" the user and device like other things.
 * We need them to always be present to know who is logged in and which device is selected.
 * But we want to be able to refresh them if the sync button is pressed.
 * It works by storing a lastSynced date for currentDevice and currentUser,
 * and calling the refreshDevice and refreshCurrentUser methods if that lastSynced date is
 * not present.
 * The lastSynced date is set in deviceManager and userService.
 */
class AuthSyncer extends AbstractSyncer {
    // This duplication of parameters being passed to the superclass' constructor looks silly but it's
    // necessary for Angular's injector to work.
    constructor(
        $injector,
        dataStore,
        eventBus,
        localStorageDataStore,
        syncStateManager
    ) {
        super(
            $injector,
            dataStore,
            eventBus,
            localStorageDataStore,
            syncStateManager
        );

        /**
         * @type {ConsoleLogger}
         */
        this.log = logFactory('AuthSyncer');
    }

    getManagedTableNames() {
        // The current user and current device are stored in localstorage not IndexedDB,
        // so there are no tables managed by this syncer.
        return [];
    }

    getSyncFunctions() {
        return [
            {
                name: 'currentDevice',
                parallel: true,
                func: () => {
                    return this.$injector.get('deviceManager').refreshDevice();
                },
            },
            {
                name: 'currentUser',
                parallel: true,
                func: () => {
                    return this.$injector.get('userService').refreshCurrentUser();
                },
            },
        ];
    }

    requiresBranch() {
        return false;
    }

    async clear() {
        // There are no IDB tables to clear here, so just remove the lastSync date from localstorage.
        const tableNames = [
            'currentDevice',
            'currentUser',
        ];

        tableNames.forEach((tableName) => {
            // Remove the metadata about the last sync of this table from localstorage.
            this.log.debug('Clearing last sync for', tableName);
            this.syncStateManager.remove(tableName);
        });
    }
}

module.exports = AuthSyncer;
